import { useState } from "react";
import { useDispatch } from "react-redux";

import {
  bulkAllocateCompanyEventRequestsRequest,
  bulkRemoveCompanyEventRequestsRequest,
  bulkUnassignCompanyEventRequestsRequest,
} from "../../../../../../store/CompanyPortal/EventRequests/actions";

const useApplicantsBulkModals = ({
  listParams,
  onRefreshEvent,
  selectedApplicants,
  setSelectedIds,
  setSelectedRowsById,
}) => {
  const dispatch = useDispatch();
  const [isAllocateModalOpen, setIsAllocateModalOpen] = useState(false);
  const [isUnassignModalOpen, setIsUnassignModalOpen] = useState(false);
  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);

  const clearSelection = () => {
    setSelectedIds([]);
    setSelectedRowsById({});
  };

  const closeAllocateModal = () => {
    setIsAllocateModalOpen(false);
  };

  const closeUnassignModal = () => {
    setIsUnassignModalOpen(false);
  };

  const closeRemoveModal = () => {
    setIsRemoveModalOpen(false);
  };

  const handleAllocateConfirm = (selectedZone, applicantIds) => {
    const eventRequestIds = (applicantIds ?? []).map((entry) =>
      entry != null && typeof entry === "object"
        ? entry.requestId ?? entry.id
        : entry,
    );

    if (!selectedZone?.id || !eventRequestIds.length) return;

    dispatch(
      bulkAllocateCompanyEventRequestsRequest({
        eventRequestIds,
        zoneId: selectedZone.id,
        listParams,
        onSuccess: () => {
          clearSelection();
          closeAllocateModal();
          onRefreshEvent?.({ silent: true });
        },
      }),
    );
  };

  const handleUnassignConfirm = (applicantIds) => {
    dispatch(
      bulkUnassignCompanyEventRequestsRequest({
        eventRequestIds: applicantIds,
        listParams,
        onSuccess: () => {
          clearSelection();
          closeUnassignModal();
          onRefreshEvent?.({ silent: true });
        },
      }),
    );
  };

  const handleRemoveConfirm = ({ reason }) => {
    dispatch(
      bulkRemoveCompanyEventRequestsRequest({
        eventRequestIds: selectedApplicants.map((row) => row.id),
        removalReason: reason,
        listParams,
        onSuccess: () => {
          clearSelection();
          closeRemoveModal();
          onRefreshEvent?.({ silent: true });
        },
      }),
    );
  };

  return {
    closeAllocateModal,
    closeRemoveModal,
    closeUnassignModal,
    handleAllocateConfirm,
    handleRemoveConfirm,
    handleUnassignConfirm,
    isAllocateModalOpen,
    isRemoveModalOpen,
    isUnassignModalOpen,
    openAllocateModal: () => setIsAllocateModalOpen(true),
    openRemoveModal: () => setIsRemoveModalOpen(true),
    openUnassignModal: () => setIsUnassignModalOpen(true),
  };
};

export default useApplicantsBulkModals;
